import { Card, Col, List, Row, Skeleton, Space, Spin, Steps, Switch } from "antd";
import { memo, useEffect } from "react";
import {
  DropDown,
  InputField,
  SearchInput,
  SubmitButton,
  TextComponent,
  TextareaField,
} from "../../../../components";
import styles from "./PlanningForm.module.css";
import {
  BiChevronDown,
  BiChevronLeft,
  BiChevronRight,
  BiChevronUp,
} from "react-icons/bi";
import { useState } from "react";
import { MdAdd, MdDelete } from "react-icons/md";
import Dropdown from "../../../../components/dropdowns/Dropdown";
import Modal from "../../../../components/modal/Modal";
import { useLocation, useNavigate } from "react-router-dom";
import { VscTrash } from "react-icons/vsc";
import { EditIcon } from "../../../../components/icons/Icons";
import { IoCheckmarkCircle } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { PlanningTemplatesMiddleware } from "../../../../Store/Middlewares/PlanningTemplatesMiddleware";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import { HiOutlineLockClosed } from "react-icons/hi2";
import { AiFillCheckSquare, AiFillLeftSquare, AiFillPlusCircle, AiOutlineBorder, AiOutlineLeftSquare, AiOutlineRightSquare } from "react-icons/ai";
import { FaCheckSquare } from "react-icons/fa";
import { IoIosRadioButtonOn } from "react-icons/io";
import { clearQuestion } from "../../../../Store/Actions/PlanningTemplatesAction";
import DraggableList from "react-draggable-list";
import { roles } from "../../../../config/roles";
import Storage from "../../../../utills/AsyncStorage";
import { PlaylistMiddleware } from "../../../../Store/Middlewares/PlaylistMiddleware";
import Meta from "antd/es/card/Meta";
import dummyImg from "../../../../assets/dummy.jpg";

const planningItems = [
  {
    title: "Bar Details",
    public: true,
  },
  {
    title: "General Information",
  },
];

const toggleInp = [
  { title: "Add Question", value: false },
  { title: "Visibility", value: true },
  { title: "Add Note (For Client)", value: false },
];

const RenderPlanningItem = memo(
  ({
    title,
    topic,
    setTopic,
    publicTemplate,
    setEditSection,
    item,
    onPressEditIcon,
    setDeleteSection,
    setsectionID,
    getQuestion,
    setSectionDetails,
    dragable,
    itemSelected,
    setSelectedPlaylist,
  }) => {
    const scale = itemSelected * 0.05 + 1;
    const shadow = itemSelected * 15 + 1;
    const {
      state: { tempData },
    } = useLocation();
    const sectionItem = useLocation().state.item;

    const role = Storage.getERole("@role");
    return (
      <Row
        className={styles.itemRow}
        // {...dragable}
        style={{
          transform: `scale(${scale})`,
          boxShadow: `rgba(0, 0, 0, 0.3) 0px ${shadow}px ${2 * shadow}px 0px`,
        }}
        onClick={() => {
          setTopic(title);
          getQuestion(item?.id);
          setSectionDetails(item);
          setSelectedPlaylist(item?.playlist_ids);
        }}
      >
        <Col>
          {item?.visibility == "public" ? (
            <TextComponent
              text={"(" + item?.visibility + ")"}
              textClass={styles.publicText}
            />
          ) : (
            <HiOutlineLockClosed />
          )}

          <Row>
            <TextComponent
              textClass={`${styles.itemTitle} ${topic === title && styles.itemTitleSelected
                }`}
            >
              {title}
            </TextComponent>
            {/* {item.public && (
              <TextComponent textClass={styles.status}>
                {"(Public)"}
              </TextComponent>
            )} */}
          </Row>
        </Col>
        <Col className={styles.iconCol}>
          <Row
            gutter={4}
            justify={"center"}
            style={{ position: "relative", flexWrap: "nowrap" }}
          >
            {publicTemplate ? null : (
              <>
                {role == roles.vendor && (
                  <>
                    <Col>
                      <div
                        className={styles.iconBtn}
                        onClick={() => {
                          setDeleteSection(true);
                          setsectionID(item?.id);
                        }}
                      >
                        <VscTrash />
                      </div>
                    </Col>
                    {sectionItem?.planningtemplate_id == tempData?.id && (
                      <Col>
                        <div
                          className={styles.iconBtn}
                          onClick={(e) => {
                            e.stopPropagation();
                            onPressEditIcon(item);
                          }}
                        >
                          <EditIcon size={22} />
                        </div>
                      </Col>
                    )}
                    <Col>
                      <div
                        className={styles.iconBtn}
                        {...dragable}
                      >
                        <span style={{ cursor: "grab", userSelect: "none" }}>☰</span>
                      </div>
                    </Col>
                  </>
                )}
              </>
            )}
            <Col>
              {topic === title ? (
                <BiChevronLeft style={{ fontSize: "2rem" }} />
              ) : (
                <BiChevronRight style={{ fontSize: "2rem" }} />
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
);

const RenderQuestion = memo(
  ({
    item,
    setQuestions,
    publicTemplate,
    number,
    setAddQuestion,
    setEdit,
    setquestionID,
    setQuestion,
    setCategory,
    setOptionArr,
    addQuestion,
    onPressEditQuesIcon,
    section,
    setisDelete,
    sectionDetails,
  }) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    // const tempData = useLocation().state.item;
    const {
      state: { tempData },
    } = useLocation();
    const sectionItem = useLocation().state.item;
    const handleOptions = (item, option) => {
      setQuestions((prev) =>
        prev.map((ques) => {
          if (ques.title === item.title) {
            return {
              ...item,
              options: item.options.map((op) => {
                if (op === option) {
                  return {
                    ...option,
                    selected: !option.selected,
                  };
                } else {
                  if (item.type === "radio") {
                    return { ...op, selected: false };
                  } else {
                    return op;
                  }
                }
              }),
            };
          } else {
            return ques;
          }
        })
      );
    };
    // console.log("==============================",section?.planningtemplate_id, tempData?.id);
    return (
      <Row className={styles.rightColRow}>
        <Col xs={24}>
          <div className={styles.questionRow}>
            <Row className={styles.question}>
              <Col>
                <TextComponent textClass={styles.questionText}>
                  Question #{number}
                </TextComponent>
              </Col>
              <Col>
                <Row
                  gutter={8}
                  justify={"center"}
                  style={{ position: "relative" }}
                >
                  {publicTemplate
                    ? null
                    : section?.planningtemplate_id == tempData?.id && (
                      <>
                        <Col>
                          <div
                            className={styles.iconBtn}
                            onClick={() => {
                              setquestionID(item?.id);
                              setisDelete(true);
                            }}
                          >
                            <VscTrash />
                          </div>
                        </Col>
                        <Col>
                          <div
                            className={styles.iconBtn}
                            onClick={(e) => {
                              e.stopPropagation();
                              setEdit(item);
                              // setEdit(true);
                              // onPressEditQuesIcon(item);
                              // setAddQuestion(true);
                              // setquestionID(item?.id);
                              // setQuestion(item?.question);
                              // setOptionArr(item?.option);
                              // setCategory(
                              //   item?.type == "set_option"
                              //     ? {
                              //       id: "set_option",
                              //       name: "Set Options",
                              //       value: "set_option",
                              //     }
                              //     : item?.type == "multiple_option"
                              //     ? {
                              //         id: "multiple_option",
                              //         name: "Multiple Choice",
                              //         value: "multiple_option",
                              //       }
                              //     : item?.type == "own_words"
                              //     ? {
                              //         id: "own_words",
                              //         name: "Own Words",
                              //         value: "own_words",
                              //       }
                              //     : null
                              // );
                            }}
                          >
                            <EditIcon size={22} />
                          </div>
                        </Col>
                      </>
                    )}
                  <Col>
                    <TextComponent
                      textClass={styles.dropdownArrow}
                      onClick={() => setDropdownOpen((prev) => !prev)}
                    >
                      {dropdownOpen ? (
                        <BiChevronUp className={styles.dropdownIcon} />
                      ) : (
                        <BiChevronDown className={styles.dropdownIcon} />
                      )}
                    </TextComponent>
                  </Col>
                </Row>
              </Col>
            </Row>
            {dropdownOpen && (
              <div className={styles.optionsContainer}>
                <InputField value={item?.question} disabled={true} />
                {/* <DropDown
                  label="Answer Type"
                  labelClass={styles.questionText}
                  stylesClass={styles.answerTypeDropdown}
                  placeholder="Type Here"
                  options={[
                    { option: "Text", value: "Text" },
                    { option: "Radio", value: "Radio" },
                    { option: "Checkbox", value: "Checkbox" },
                  ]}
                /> */}
                <TextComponent
                  text={"Answer Type"}
                  textClass={styles.questionText}
                />
                {item?.type == "set_option" ||
                  item?.type == "multiple_option" ? (
                  <div>
                    {item?.options?.map((options, index) => {
                      return (
                        <div className={styles.optionItem}>
                          {item?.type == "multiple_option" ? (
                            <FaCheckSquare className={styles.optionIcon} />
                          ) : (
                            <IoIosRadioButtonOn className={styles.optionIcon} />
                          )}
                          <TextComponent
                            text={options?.name}
                            textClass={styles.optionText}
                          />
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <InputField disabled={true} placeholder={"Text Box"} />
                )}
              </div>
            )}
          </div>
        </Col>
      </Row>
    );
  }
);

const ques = [{ question: "" }, { question: "" }, { question: "" }];

const PlanningForm = () => {
  const [questions, setQuestions] = useState(ques);
  const [addQuestion, setAddQuestion] = useState(false);
  const [editQuestion, setEditQuestion] = useState(false);
  const [addSection, setAddSection] = useState(false);
  const [editSection, setEditSection] = useState(false);
  const [toggleInputs, setToggleInputs] = useState(toggleInp);
  // Add sections functionality
  const [deleteSection, setDeleteSection] = useState(false);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [Visibility, setVisibility] = useState("");
  const [musicLimit, setMusicLimit] = useState();
  const [isMusic, setIsMusic] = useState(true);
  const [sectionID, setsectionID] = useState(null);
  const [secList, setSectionlist] = useState([]);
  const SectionList = useSelector(
    (state) => state.PlanningTemplatesReducer.SubSectionList
  );
  const user = useSelector((state) => state.AuthReducer.user);
  const [sectionDetails, setSectionDetails] = useState();
  // SectionList[0]
  const [topic, setTopic] = useState();
  // SectionList[0]?.name

  const {
    state: { publicTemplate, item, screenType, tempData, shared_planning_template_id },
  } = useLocation();

  console.log('PlanningForm item', shared_planning_template_id)


  const [isSongsIdeas, setisSongsIdeas] = useState(false)
  const [songsIdeas, setsongsIdeas] = useState(null)
  const [vendorPlaylist, setvendorPlaylist] = useState([])
  const [BDEPlaylist, setBDEPlaylist] = useState([])
  const [isUpload, setisUpload] = useState(false)

  const [showvendorPlaylist, setShowvendorPlaylist] = useState(true)
  const [showBDEPlaylist, setShowBDEPlaylist] = useState(false)
  const [SelectedPlaylist, setSelectedPlaylist] = useState([])
  const role = Storage.getERole("@role");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(PlanningTemplatesMiddleware.getSubSections({ id: item?.id, shared_planning_template_id: shared_planning_template_id })).then(
      (data) => {
        setSectionlist(data);
        setSectionDetails(data[0]);
        setSelectedPlaylist(data[0]?.playlist_ids)
        setTopic(data[0]?.name);
        getQuestion(data[0]?.id);
      }
    );
  }, []);


  const GetSubSections = () => {
    dispatch(PlanningTemplatesMiddleware.getSubSections({ id: item?.id, shared_planning_template_id: shared_planning_template_id })).then(
      (data) => {
        setSectionlist(data);
        setSectionDetails(data[0]);
        setSelectedPlaylist(data[0]?.playlist_ids)
        setTopic(data[0]?.name);
        getQuestion(data[0]?.id);
      }
    );
  };
  const onPressEditIcon = (item) => {
    setEditSection(true);
    setsectionID(item?.id);
    setTitle(item?.name);
    setDescription(item?.description);
    setVisibility(item?.visibility == "public" ? true : false);
    setIsMusic(item?.is_music == 0 ? false : true)
    setMusicLimit(`${item?.music_limit}`)
  };
  const onCreateSection = () => {
    if (!user?.is_subscribed) {
      dispatch(
        showAlert({
          type: "error",
          message: "Pleare subscribe to add section",
        })
      );
      return;
    }
    if (!title) {
      dispatch(
        showAlert({
          type: "Error",
          message: "All fields are mandatory",
        })
      );
    } else {
      setAddSection(false);
      dispatch(
        PlanningTemplatesMiddleware.createSubSection({
          id: item?.id,
          plainningid: item?.planningtemplate_id,
          name: title,
          Description: description,
          // visibility: Visibility ? "public" : "client",
          visibility: sectionDetails?.visibility,
          isMusic,
          musicLimit,
        })
      )
        .then((data) => {
          setSectionlist([data, ...secList]);
          setTitle("");
          setDescription("");
          setVisibility(false);
          setMusicLimit("");
        })
        .catch(() => {
          setAddSection(true);
        });
    }
  };
  const onEditSection = () => {
    if (isMusic) {
      if (!musicLimit) {
        dispatch(
          showAlert({
            type: "Error",
            message: "Add music limit",
          })
        );
        return;
      }
    }
    if (!title) {
      dispatch(
        showAlert({
          type: "Error",
          message: "All fields are mandatory",
        })
      );
    } else {
      setEditSection(false);
      dispatch(
        PlanningTemplatesMiddleware.editSection({
          template_id: item?.id,
          sectionID: sectionID,
          name: title,
          Description: description,
          visibility: sectionDetails?.visibility,
          isMusic,
          musicLimit,
        })
      )
        .then((data) => {
          let index = secList.findIndex((item) => item.id == data.id);

          setSectionlist((prev) => {
            prev.splice(index, 1, data);
            return prev;
          });
          setsectionID(null);
          setTitle("");
          setDescription("");
          setVisibility(false);
          setMusicLimit("");
        })
        .catch(() => {

        });
    }
  };

  const deleteCallback = (data) => {
    let index = secList.findIndex((item) => item.id == data.id);
    setSectionlist((prev) => {
      prev.splice(index, 1);
      return prev;
    });
    dispatch(PlanningTemplatesMiddleware.getSubSections({ id: item?.id, shared_planning_template_id: shared_planning_template_id })).then(
      (data) => {
        console.log("datadatadatadata", data);
        setSectionlist(data);
        setSectionDetails(data[0]);
        setTopic(data[0]?.name);
        getQuestion(data[0]?.id);
      }
    );
    setDeleteSection(false);
  };

  const onDeleteSection = () => {
    console.log('onDeleteSection item', item)
    if (item?.planningtemplate_id == tempData?.id) {
      dispatch(
        PlanningTemplatesMiddleware.deleteSection({
          id: sectionID,
        })
      )
        .then(deleteCallback)
        .catch(() => {
          setDeleteSection(false);
        });
    } else {
      let data = {
        section_id: sectionDetails?.id,
        planningtemplate_id: item?.planningtemplate_id,
        shared_planning_template_id: shared_planning_template_id
      };
      dispatch(PlanningTemplatesMiddleware.unlinkTemplateSection(data))
        .then(deleteCallback)
        .catch((err) => {
          setsectionID(null);
          console.log(err);
        });
    }
  };
  // const onChange = (check, title) => {
  //   setToggleInputs((prev) =>
  //     prev.map((input) => {
  //       if (input.title === title) {
  //         return { ...input, value: check };
  //       } else {
  //         return input;
  //       }
  //     })
  //   );
  // };
  // Add Question functionality
  const dropdown_options = [
    {
      id: "set_option",
      name: "Dropdown",
      val: "set_option",
    },
    {
      id: "multiple_option",
      name: "Check Box",
      val: "multiple_option",
    },
    {
      id: "own_words",
      name: "Text Box",
      val: "own_words",
    },
  ];
  const [question, setQuestion] = useState("");
  const [category, setCategory] = useState(null);
  // console.log("categorryyyyyy", category);
  const [optionAnswer, setoptionAnswer] = useState("");
  const [optionArr, setOptionArr] = useState([]);
  // console.log("OptionAAAAAAA", optionArr);
  const [edit, setEdit] = useState(null);
  const [questionID, setquestionID] = useState(null);
  const [isDelete, setisDelete] = useState(false);
  const QuestionList = useSelector(
    (state) => state.PlanningTemplatesReducer.QuestionList
  );

  useEffect(() => {
    dispatch(PlanningTemplatesMiddleware.getQuestions(SectionList[0]?.id));
    return () => {
      // console.log("clearQuestion===========>>>>>>", clearQuestion());
      dispatch(clearQuestion());
    };
  }, []);
  const getQuestion = (id) => {
    dispatch(PlanningTemplatesMiddleware.getQuestions(id));
  };
  const addOption = () => {
    // console.log("addOption", optionArr);

    if (!optionAnswer) {
      dispatch(
        showAlert({
          type: "Error",
          message: "Type option first!",
        })
      );
    } else {
      let dummyArr = optionArr?.length > 0 ? [...optionArr] : [];
      dummyArr.push({ id: optionArr?.length + 1, name: optionAnswer });
      setOptionArr(dummyArr);
      setoptionAnswer("");
    }
  };
  const deleteOption = (index) => {
    let dummyArr = [...optionArr];
    dummyArr.splice(index, 1);
    setOptionArr(dummyArr);
  };
  const onCreateQuestion = () => {
    if (!question || !category) {
      dispatch(
        showAlert({
          type: "Error",
          message: "Question and answer type are mandatory!",
        })
      );
    } else if (category?.val == "Check Box" || category?.val == "Dropdown") {
      if (!optionArr) {
        dispatch(
          showAlert({
            type: "Error",
            message: "Add atleast 1 options!",
          })
        );
      } else {
        edit ? onEditQuestion() : onAddQuestion();
      }
    } else {
      edit ? onEditQuestion() : onAddQuestion();
    }
  };
  const onAddQuestion = () => {
    setAddQuestion(false);
    let questionData = {
      id: sectionDetails?.id,
      question,
      type: category?.id,
      optionArray: optionArr,
    };
    dispatch(PlanningTemplatesMiddleware.createQuestion(questionData))
      .then(() => {
        setQuestion("");
        setCategory(null);
        setOptionArr([]);
      })
      .catch((err) => {
        setAddQuestion(true);
        // console.log(err);
      });
  };
  useEffect(() => {
    if (edit) {
      onPressEditQuesIcon(edit);
    } else {
      setquestionID(null);
      setQuestion("");
      setOptionArr([]);
      setCategory(null);
    }
  }, [edit]);
  const onPressEditQuesIcon = (item) => {
    // console.log("editIconItem", item);
    setAddQuestion(true);
    setquestionID(item?.id);
    setQuestion(item?.question);
    setOptionArr(item?.options);
    setCategory(
      item?.type == "set_option"
        ? {
          id: "set_option",
          name: "Dropdown",
          val: "Dropdown",
        }
        : item?.type == "multiple_option"
          ? {
            id: "multiple_option",
            name: "Check Box",
            val: "Check Box",
          }
          : item?.type == "own_words"
            ? {
              id: "own_words",
              name: "Text Box",
              val: "Text Box",
            }
            : null
    );
  };
  const onEditQuestion = () => {
    setAddQuestion(false);
    let questionData = {
      id: sectionDetails?.id,
      questionID,
      question,
      type: category?.id,
      optionArray: optionArr,
    };
    dispatch(PlanningTemplatesMiddleware.editQuestion(questionData))
      .then(() => {
        setEdit(null);
        // setAddQuestion(false);
        setquestionID(null);
        setQuestion("");
        setCategory(null);
        setOptionArr([]);
      })
      .catch((err) => {
        setAddQuestion(true);
        // console.log(err);
      });
  };
  const onPressYes = () => {
    setisDelete(false);
    let questionData = {
      id: questionID,
    };
    dispatch(PlanningTemplatesMiddleware.deleteQuestion(questionData))
      .then(() => setquestionID(null))
      .catch((err) => {
        setquestionID(null);
        // console.log(err);
      });
  };

  const submitPlaylist = () => {
    setisUpload(true)
    dispatch(PlaylistMiddleware.addPlaylistIdInTemplateSection({ Queries: SelectedPlaylist, id: sectionDetails?.id })).then((data) => {
      setisUpload(false)
      setisSongsIdeas(false)
      GetSubSections()
    })
  }

  const renderSpotifyPlaylists = (item) => {
    let find = SelectedPlaylist.find(i => i?.id ? i?.id == item?.id : i == item?.id)
    console.log('find', find);
    console.log('SelectedPlaylist', SelectedPlaylist);
    return (
      <List.Item
      >
        <Card
          hoverable
          style={{ width: "100%", textAlign: "center", alignItems: "center" }}
          cover={
            <img
              className={styles.image}
              src={item?.image ? item?.image : dummyImg}
              alt="example"
              resizeMode="contain"
            />
          }
        >
          <Meta
            style={{ textAlign: "center" }}
            title={
              <>
                <TextComponent
                  text={item.name ? item.name : '--'}
                  textClass={styles.songsText}
                />
              </>
            }
          // description={<TextComponent text={item.description} />}
          />

          <div style={{ marginBottom: 10 }} onClick={() => {

            const itemId = String(item?.id);
            const isAlreadySelected = SelectedPlaylist.find(i => String(i) === itemId);
            if (isAlreadySelected) {
              let data = [...SelectedPlaylist];
              let index = data.findIndex(i => String(i) === itemId);
              if (index !== -1) {
                data.splice(index, 1);
              }
              setSelectedPlaylist(data);
            } else {
              let data = [...SelectedPlaylist];
              data.push(item?.id); // push as-is (string or number, up to you)
              setSelectedPlaylist(data);
            }
          }}>
            {
              find ?
                <AiFillCheckSquare color="#00000" size={20} />
                :
                <AiOutlineBorder color="#00000" size={20} />
            }
            {/* <FontAwesome name={find ? "check-square-o" : "square-o"} size={22} color={Theme.Primary} /> */}
          </div>
        </Card>
      </List.Item>
    );
  }


  return (
    <>
      <Row>
        <Col xs={24} lg={9} className={styles.leftCol}>
          <Row className={styles.inputRow} gutter={8}>
            <Col xs={24} sm={17}>
              {/* <SearchInput placeholder="Search Form" /> */}
            </Col>
            <Col xs={24} sm={7}>
              {/* <SubmitButton title="Search" btnClass={styles.btn} /> */}
            </Col>
          </Row>
          {role == roles.vendor ? (
            <DraggableList
              className={styles.planningItemsList}
              list={secList}
              itemKey="id"
              onMoveEnd={(newList) => {
                setSectionlist(newList);
                dispatch(PlanningTemplatesMiddleware.sortedSections(newList));
              }}
              template={(props) => {

                return (
                  <RenderPlanningItem
                    key={props?.item.id}
                    title={props?.item?.name}
                    item={props?.item}
                    itemSelected={props.itemSelected}
                    dragable={props.dragHandleProps}
                    topic={topic}
                    setTopic={setTopic}
                    setEditSection={setEditSection}
                    setDeleteSection={setDeleteSection}
                    publicTemplate={publicTemplate}
                    setSectionDetails={setSectionDetails}
                    onPressEditIcon={onPressEditIcon}
                    setsectionID={setsectionID}
                    getQuestion={getQuestion}
                    setSelectedPlaylist={setSelectedPlaylist}
                  />
                );
              }}
            />
          ) : (
            <List
              className={styles.planningItemsList}
              dataSource={secList}
              // itemKey="id"
              // onMoveEnd={(newList) => {
              //   setSectionlist(newList);
              //   dispatch(PlanningTemplatesMiddleware.sortedSections(newList));
              // }}
              renderItem={(item) => {
                return (
                  <RenderPlanningItem
                    key={item.id}
                    title={item?.name}
                    item={item}
                    // itemSelected={itemSelected}
                    // dragable={dragHandleProps}
                    topic={topic}
                    setTopic={setTopic}
                    setEditSection={setEditSection}
                    setDeleteSection={setDeleteSection}
                    publicTemplate={publicTemplate}
                    setSectionDetails={setSectionDetails}
                    onPressEditIcon={onPressEditIcon}
                    setsectionID={setsectionID}
                    getQuestion={getQuestion}
                  />
                );
              }}
            />
          )}
          {!publicTemplate ? (
            <Space
              direction="vertical"
              size={"small"}
              className={styles.btnSpace}
            >
              {role == roles.vendor && (
                <SubmitButton
                  title="Add Sub Section"
                  btnClass={styles.sectionBtnDark}
                  onClick={() => {
                    if (!user?.is_subscribed) {
                      dispatch(
                        showAlert({
                          type: "error",
                          message: "Pleare subscribe to add section",
                        })
                      );
                      return;
                    }
                    setAddSection(true);
                  }}
                />
              )}
              {screenType == "event" && (
                <SubmitButton
                  title="Prepare Event"
                  leftIcon={<IoCheckmarkCircle size={20} />}
                  btnClass={styles.sectionBtn}
                  onClick={() =>
                    navigate(
                      "/events/eventDetail/templateDetail/planningForm/1",
                      {
                        state: {
                          headrTitle: "Planning Form",
                          temp_id: item?.planningtemplate_id,
                          parent_id: item?.id,
                          shared_planning_template_id: shared_planning_template_id
                        },
                      }
                    )
                  }
                />
              )}
            </Space>
          ) : (
            <></>
          )}
        </Col>
        <Col xs={24} lg={15} className={styles.rightCol}>
          {sectionDetails && (
            <Row className={styles.headingRow}>
              <Col>
                <TextComponent textClass={styles.heading}>
                  {topic}
                </TextComponent>
                {/* &nbsp;
              <TextComponent textClass={styles.headingNumbers}>
                (1/{ques.length})
              </TextComponent> */}
              </Col>
              {publicTemplate
                ? null
                : ///////////////////////////////////////////////////////////////////
                item?.planningtemplate_id == tempData?.id && (
                  <Col>
                    {role == roles.vendor && (
                      <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <SubmitButton
                          title="Add Question"
                          leftIcon={<MdAdd size={20} />}
                          outline={true}
                          btnClass={styles.addQuesBtn}
                          // onClick={() => setAddQuestion(true)}
                          onClick={() => {
                            if (!user?.is_subscribed) {
                              dispatch(
                                showAlert({
                                  type: "Error",
                                  message: "Please subscribe to add questions",
                                })
                              );
                            } else {
                              setEdit(null);
                              onPressEditQuesIcon();
                            }
                          }}
                        />
                        {sectionDetails?.is_music &&
                          <SubmitButton
                            title="Songs Ideas"
                            leftIcon={<MdAdd size={20} />}
                            outline={true}
                            btnClass={styles.addQuesBtn}
                            // onClick={() => setAddQuestion(true)}
                            onClick={() => {
                              dispatch(PlaylistMiddleware.getAllPlaylist()).then((data) => {

                                setTimeout(() => {
                                  setBDEPlaylist(data?.admin_playlist)
                                  setvendorPlaylist(data?.my_playlist)
                                  setisSongsIdeas(true)
                                }, 1000);
                              }).catch()
                            }}
                          />
                        }
                      </div>
                    )}
                  </Col>
                )}
            </Row>
          )}
          <Steps
            direction="vertical"
            current={QuestionList?.length - 1}
            style={{ margin: "30px auto 20px auto" }}
          >
            {QuestionList?.map((questions, i) => (
              <Steps.Step
                title={
                  <RenderQuestion
                    item={questions}
                    setQuestions={setQuestions}
                    setEditQuestion={setEditQuestion}
                    publicTemplate={publicTemplate}
                    setAddQuestion={setAddQuestion}
                    setEdit={setEdit}
                    setquestionID={setquestionID}
                    setQuestion={setQuestion}
                    setCategory={setCategory}
                    setOptionArr={setOptionArr}
                    addQuestion={addQuestion}
                    number={i + 1}
                    onPressEditQuesIcon={onPressEditQuesIcon}
                    setisDelete={setisDelete}
                    sectionDetails={sectionDetails}
                    section={item}
                  />
                }
                icon={
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 36 36"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M0.433594 17.7695C0.433594 8.21132 8.18788 0.457031 17.7461 0.457031C27.3043 0.457031 35.0586 8.21132 35.0586 17.7695C35.0586 27.3277 27.3043 35.082 17.7461 35.082C8.18788 35.082 0.433594 27.3277 0.433594 17.7695ZM17.7461 3.12049C9.65887 3.12049 3.09706 9.68231 3.09706 17.7695C3.09706 25.8568 9.65887 32.4186 17.7461 32.4186C25.8333 32.4186 32.3951 25.8568 32.3951 17.7695C32.3951 9.68231 25.8333 3.12049 17.7461 3.12049Z"
                      fill="var(--primary-color)"
                    />
                    <path
                      d="M17.7524 28.9305C23.9172 28.9305 28.9149 23.9329 28.9149 17.768C28.9149 11.6031 23.9172 6.60547 17.7524 6.60547C11.5875 6.60547 6.58984 11.6031 6.58984 17.768C6.58984 23.9329 11.5875 28.9305 17.7524 28.9305Z"
                      fill="var(--primary-color)"
                    />
                  </svg>
                }
              />
            ))}
          </Steps>
        </Col>
      </Row>
      {/* {addQuestion && ( */}
      {addQuestion && (
        <Modal
          isModalOpen={addQuestion}
          setIsModalOpen={setAddQuestion}
          closable={true}
          onClose={() => {
            setCategory(null);
            setEdit(null);
          }}
          className={styles.modal}
        >
          <div className={styles.modalCon}>
            <TextComponent
              text={`${edit ? "Edit" : "Add"} Question`}
              textClass={styles.modalHeading}
            />
            <Space
              direction="vertical"
              size="small"
              style={{
                display: "flex",
                marginTop: "10px",
              }}
            >
              <InputField
                label="Your Question"
                name="yourQuestion"
                placeholder="Type question here"
                value={question}
                onChange={(e) => setQuestion(e.target.value)}
              />
              <Dropdown
                label="Select Answer Type"
                name="answerType"
                placeholder="Select category"
                //   options={
                //     [
                //     { value: "Set_Options", option: "Set Options" },
                //     { value: "Multiple Choice", option: "Multiple Choice" },
                //     { value: "Own Words", option: "Own Words" },
                //   ]
                // }
                object={dropdown_options}
                onChange={(e) => setCategory(e)}
                selectedValue={category?.val}
              />
              {category?.id == "own_words" ? (
                <InputField
                  label="Your Answer"
                  // name="answerType"
                  placeholder="Type answer here"
                  disabled={true}
                />
              ) : category?.id == "multiple_option" ||
                category?.id == "set_option" ? (
                <InputField
                  label="Add option"
                  // name="answerType"
                  placeholder="Type option here"
                  value={optionAnswer}
                  onChange={(e) => setoptionAnswer(e.target.value)}
                  rightIcon={<AiFillPlusCircle className={styles.plusicon} />}
                  onRightIconPress={addOption}
                />
              ) : null}
              {optionArr?.map((item, index) => {
                return (
                  <div key={item?.id}>
                    {category?.id == "multiple_option" ||
                      category?.id == "set_option" ? (
                      <div className={styles.optionCon}>
                        <div className={styles.optionConLeft}>
                          {category?.id == "multiple_option" ? (
                            <FaCheckSquare className={styles.optionIcon} />
                          ) : (
                            <IoIosRadioButtonOn className={styles.optionIcon} />
                          )}
                          <TextComponent text={item?.name} />
                        </div>
                        <div
                          className={styles.optionConRight}
                          onClick={() => deleteOption(index)}
                        >
                          <MdDelete className={styles.deleteOptIcon} />
                        </div>
                      </div>
                    ) : null}
                  </div>
                );
              })}
            </Space>
            <Col xs={24} lg={15}>
              <SubmitButton
                title={`${edit ? "Update" : "Add"} Question`}
                btnClass={styles.modalBtnTemplate}
                onClick={onCreateQuestion}
              />
            </Col>
          </div>
        </Modal>
      )}
      {/* )} */}
      {/* {editQuestion && ( */}
      {editQuestion && (
        <Modal
          isModalOpen={editQuestion}
          setIsModalOpen={setEditQuestion}
          closable={true}
          className={styles.modal}
        >
          <div className={styles.modalCon}>
            <TextComponent
              text={"Edit Question"}
              textClass={styles.modalHeading}
            />
            <Space
              direction="vertical"
              size="small"
              style={{
                display: "flex",
                marginTop: "10px",
              }}
            >
              <InputField
                label="Your Question"
                name="yourQuestion"
                placeholder="Bridal Information"
              />
              <Dropdown
                label="Select Answer Type"
                name="answerType"
                placeholder="Bridal Information"
                options={[
                  { value: "Set Options", option: "Set Options" },
                  { value: "Own Words", option: "Own Words" },
                ]}
              />
            </Space>
            <Col xs={24} lg={15}>
              <SubmitButton
                title="Save"
                btnClass={styles.modalBtnTemplate}
                onClick={() => setEditQuestion(false)}
              />
            </Col>
          </div>
        </Modal>
      )}
      {/* )} */}
      {addSection && (
        <Modal
          isModalOpen={addSection}
          setIsModalOpen={setAddSection}
          closable={true}
          className={styles.modal}
          wideModal
        >
          <div className={styles.modalCon}>
            <TextComponent
              text={"Create Sub Section"}
              textClass={styles.modalHeading}
            />
            <Space
              direction="vertical"
              size="small"
              style={{
                display: "flex",
                marginTop: "10px",
              }}
            >
              <InputField
                label="Sub Section Name"
                name="sectionName"
                placeholder="Section Name"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
              <TextareaField
                label="Sub Section Description"
                name="eventType"
                placeholder="Description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
              {/* <div className={styles.visiCon}>
                <div className={styles.visiText}>
                  <TextComponent textClass={styles.toggleInputTitle}>
                    {"Visibility"}
                  </TextComponent>
                </div>
                <div>
                  <Switch
                    checked={Visibility}
                    onChange={() => setVisibility(!Visibility)}
                    style={{
                      backgroundColor: Visibility && "var(--primary-color)",
                    }}
                  />
                </div>
              </div> */}
              <div className={styles.visiCon}>
                <div className={styles.visiText}>
                  <TextComponent textClass={styles.toggleInputTitle}>
                    {"Music"}
                  </TextComponent>
                </div>
                <div>
                  <Switch
                    checked={isMusic}
                    onChange={() => setIsMusic(!isMusic)}
                    style={{
                      backgroundColor: isMusic && "var(--primary-color)",
                    }}
                  />
                </div>

              </div>
              {isMusic && (
                <InputField
                  label="Music Limit"
                  placeholder="Music Limit"
                  value={musicLimit}
                  onChange={(e) => setMusicLimit(e.target.value)}
                />
              )}
              {/* <Row gutter={[64, 24]} style={{ alignItems: "center" }}>
              {toggleInputs?.map((input) => (
                <Col xs={24} md={12}>
                  <Row style={{ justifyContent: "space-between" }}>
                    <Col>
                      <TextComponent textClass={styles.toggleInputTitle}>
                        {input.title}
                      </TextComponent>
                    </Col>
                    <Col>
                      <Switch
                        checked={input.value}
                        onChange={(check) => onChange(check, input.title)}
                        style={{
                          backgroundColor:
                            input.value && "var(--primary-color)",
                        }}
                      />
                    </Col>
                  </Row>
                </Col>
              ))}
              <Col xs={24} md={12}>
                <TextComponent textClass={styles.optionBtnHeading}>
                  Select Option
                </TextComponent>
                <Row gutter={8}>
                  <Col xs={12}>
                    <SubmitButton
                      title="Client"
                      leftIcon={<IoCheckmarkCircle size={20} />}
                      btnClass={styles.toggleBtn}
                      onClick={() => setOption("client")}
                      outline={option === "client" ? false : true}
                    />
                  </Col>
                  <Col xs={12}>
                    <SubmitButton
                      title="Public"
                      btnClass={styles.toggleBtn}
                      leftIcon={<IoCheckmarkCircle size={20} />}
                      onClick={() => setOption("public")}
                      outline={option === "public" ? false : true}
                    />
                  </Col>
                </Row>
              </Col>
            </Row> */}
            </Space>
            <Col xs={24} lg={15}>
              <SubmitButton
                title="Add Sub Section"
                btnClass={styles.modalBtnTemplate}
                onClick={onCreateSection}
              />
            </Col>
          </div>
        </Modal>
      )}
      {editSection && (
        <Modal
          isModalOpen={editSection}
          setIsModalOpen={setEditSection}
          closable={true}
          className={styles.modal}
          wideModal
        >
          <div className={styles.modalCon}>
            <TextComponent
              text={"Edit Sub Section"}
              textClass={styles.modalHeading}
            />
            <Space
              direction="vertical"
              size="small"
              style={{
                display: "flex",
                marginTop: "10px",
              }}
            >
              <InputField
                label="Sub Section Name"
                name="sectionName"
                placeholder="Bridal Information"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
              <TextareaField
                label="Sub Section Description"
                name="eventType"
                placeholder="Description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
              {/* <div className={styles.visiCon}>
                <div className={styles.visiText}>
                  <TextComponent textClass={styles.toggleInputTitle}>
                    {"Visibility"}
                  </TextComponent>
                </div>
                <div>
                  <Switch
                    checked={Visibility}
                    onChange={() => setVisibility(!Visibility)}
                    style={{
                      backgroundColor: Visibility && "var(--primary-color)",
                    }}
                  />
                </div>
              </div> */}
              <div className={styles.visiCon}>
                <div className={styles.visiText}>
                  <TextComponent textClass={styles.toggleInputTitle}>
                    {"Music"}
                  </TextComponent>
                </div>
                <div>
                  <Switch
                    checked={isMusic}
                    onChange={() => setIsMusic(!isMusic)}
                    style={{
                      backgroundColor: isMusic && "var(--primary-color)",
                    }}
                  />
                </div>

              </div>
              {isMusic && (
                <InputField
                  label="Music Limit"
                  placeholder="Music Limit"
                  value={musicLimit}
                  onChange={(e) => setMusicLimit(e.target.value)}
                />
              )}
              {/* <Row gutter={[64, 24]} style={{ alignItems: "center" }}>
              {toggleInputs?.map((input) => (
                <Col xs={24} md={12}>
                  <Row style={{ justifyContent: "space-between" }}>
                    <Col>
                      <TextComponent textClass={styles.toggleInputTitle}>
                        {input.title}
                      </TextComponent>
                    </Col>
                    <Col>
                      <Switch
                        checked={input.value}
                        onChange={(check) => onChange(check, input.title)}
                        style={{
                          backgroundColor:
                            input.value && "var(--primary-color)",
                        }}
                      />
                    </Col>
                  </Row>
                </Col>
              ))}
              <Col xs={24} md={12}>
                <TextComponent textClass={styles.optionBtnHeading}>
                  Select Option
                </TextComponent>
                <Row gutter={8}>
                  <Col xs={12}>
                    <SubmitButton
                      title="Client"
                      leftIcon={<IoCheckmarkCircle size={20} />}
                      btnClass={styles.toggleBtn}
                      onClick={() => setOption("client")}
                      outline={option === "client" ? false : true}
                    />
                  </Col>
                  <Col xs={12}>
                    <SubmitButton
                      title="Public"
                      btnClass={styles.toggleBtn}
                      leftIcon={<IoCheckmarkCircle size={20} />}
                      onClick={() => setOption("public")}
                      outline={option === "public" ? false : true}
                    />
                  </Col>
                </Row>
              </Col>
            </Row> */}
            </Space>
            <Col xs={24} lg={15}>
              <SubmitButton
                title="Save"
                btnClass={styles.modalBtnTemplate}
                onClick={onEditSection}
              />
            </Col>
          </div>
        </Modal>
      )}
      {deleteSection && (
        <Modal
          isModalOpen={deleteSection}
          setIsModalOpen={setDeleteSection}
          closable={true}
          className={styles.modal}
        // wideModal
        >
          <div className={styles.deleteCon}>
            <div className={styles.deleteIcon}>
              <MdDelete />
            </div>
            <TextComponent
              textClass={styles.deleteText}
              text={"Are you sure want to\n delete this sub section!"}
            />
            <SubmitButton
              title="Yes"
              btnClass={styles.modalBtnTemplate}
              onClick={onDeleteSection}
            />
          </div>
        </Modal>
      )}
      <Modal
        isModalOpen={isDelete}
        setIsModalOpen={setisDelete}
        closable={true}
        className={styles.modal}
      // wideModal
      >
        <div className={styles.deleteCon}>
          <div className={styles.deleteIcon}>
            <MdDelete />
          </div>
          <TextComponent
            textClass={styles.deleteText}
            text={"Are you sure want to\n delete this question!"}
          />
          <SubmitButton
            title="Yes"
            btnClass={styles.modalBtnTemplate}
            onClick={onPressYes}
          />
        </div>
      </Modal>

      <Modal
        isModalOpen={isSongsIdeas}
        setIsModalOpen={setisSongsIdeas}
        closable={true}
        onClose={() => {
          setisSongsIdeas(false)
          setSelectedPlaylist([])
          GetSubSections()
        }}
        className={styles.youtubeModal}
      >
        <div className={styles.modalCon}>
          <TextComponent
            text={"SELECT PLAYLIST"}
            textClass={styles.modalHeading}
          />
          <Space
            direction="vertical"
            size="small"
            style={{
              display: "flex",
              marginTop: "10px",
            }}
          >

            <div onClick={() => { setShowvendorPlaylist(!showvendorPlaylist) }} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <TextComponent
                text={"My PLAYLIST"}
                textClass={styles.modalHeading}
                style={{ marginRight: '10px' }}
              />
              {showvendorPlaylist ?
                <AiOutlineLeftSquare color="#00000" size={20} />
                :
                <AiOutlineRightSquare color="#00000" size={20} />
              }
            </div>
            {showvendorPlaylist &&
              <List
                className={styles.listClass}
                grid={{
                  xs: 1,
                  sm: 2,
                  md: 2,
                  lg: 3,
                  xl: 4,
                  xxl: 4,
                }}
                dataSource={vendorPlaylist ? vendorPlaylist : []}
                renderItem={renderSpotifyPlaylists}
              />
            }
            <div onClick={() => { setShowBDEPlaylist(!showBDEPlaylist) }} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <TextComponent
                text={"BDE PLAYLIST"}
                textClass={styles.modalHeading}
                style={{ marginRight: '10px' }}
              />
              {showBDEPlaylist ?
                <AiOutlineLeftSquare color="#00000" size={20} />
                :
                <AiOutlineRightSquare color="#00000" size={20} />
              }
            </div>
            {showBDEPlaylist &&
              <List
                className={styles.listClass}
                grid={{
                  xs: 1,
                  sm: 2,
                  md: 2,
                  lg: 3,
                  xl: 4,
                  xxl: 4,
                }}
                dataSource={BDEPlaylist ? BDEPlaylist : []}
                renderItem={renderSpotifyPlaylists}
              />
            }

            {isUpload ? <Spin size="large" />
              :
              <SubmitButton
                title={'Save'}
                onClick={submitPlaylist}
                style={styles.add_temp_button}
              />
            }

          </Space>
        </div>
      </Modal>
    </>
  );
};

export default PlanningForm;
